const matchedSubjectB2b = (xmlElement) => {
  const MatchedSubjectRoot = xmlElement.getElementsByTagName("cb:MatchedSubject")[0];
  const FlagMatched = MatchedSubjectRoot?.attributes.FlagMatched.value
  const CBSubjectCode = MatchedSubjectRoot?.attributes.CBSubjectCode.value
  if (FlagMatched !== '0') {
    console.log('FUNCTION DIJALANKAN');
    const MatchedSubject = xmlElement.getElementsByTagName("cb:MatchedSubject")[0];
    const ReferenceNo = MatchedSubject?.attributes?.ReferenceNo?.value ?? ''
    const CBSubjectCode = MatchedSubject?.attributes?.CBSubjectCode?.value ?? ''
    const FlagMatched = MatchedSubject?.attributes?.FlagMatched?.value ?? ''
    // attributes Company
    const companyRoot = MatchedSubject?.getElementsByTagName('cb:Company')[0];
    const CompanyCategory = companyRoot?.attributes?.CompanyCategory?.value ?? '';
    const LegalForm = companyRoot?.attributes?.LegalForm?.value ?? '';
    const LegalFormDesc = companyRoot?.attributes?.LegalFormDesc?.value ?? '';
    const GoPublic = companyRoot?.attributes?.GoPublic?.value ?? '';
    const GoPublicDesc = companyRoot?.attributes?.GoPublicDesc?.value ?? '';
    const Rating = companyRoot?.attributes?.Rating?.value ?? '';
    const RatingInstitution = companyRoot?.attributes?.RatingInstitution?.value ?? '';
    const RatingInstitutionDesc = companyRoot?.attributes?.RatingInstitutionDesc?.value ?? '';
    const RatingDate = companyRoot?.attributes?.RatingDate?.value ?? '';
    const EconomicSector = companyRoot?.attributes?.EconomicSector?.value ?? '';
    const EconomicSectorDesc = companyRoot?.attributes?.EconomicSectorDesc?.value ?? '';
    const LastUpdateDate = companyRoot?.attributes?.LastUpdateDate?.value ?? '';
    // attributes Company Name
    const TradeName = companyRoot?.getElementsByTagName('cb:CompanyName')[0]?.attributes?.TradeName?.value ?? '';
    // attributes CompanyEstablishment
    const CompanyEstablishment = companyRoot?.getElementsByTagName('cb:CompanyEstablishment')[0];
    const PlaceOfEstablishment = CompanyEstablishment?.attributes?.PlaceOfEstablishment?.value ?? '';
    const DeedNumberOfEstablishment = CompanyEstablishment?.attributes?.DeedNumberOfEstablishment?.value ?? '';
    const DeedDateOfEstablishment = CompanyEstablishment?.attributes?.DeedDateOfEstablishment?.value ?? '';
    const RecentlyeOfEstablishment = CompanyEstablishment?.attributes?.RecentlyeOfEstablishment?.value ?? '';
    const DateofFinalAmendmentDeedNumber = CompanyEstablishment?.attributes?.DateofFinalAmendmentDeedNumber?.value ?? '';

    // attributes Address History
    const AddressHistory = Array.from(companyRoot?.getElementsByTagName('cb:AddressHistory')).map(element => {
      const flagCurrent = element.getAttribute('FlagCurrent');
      const lastUpdateDate = element.getAttribute('LastUpdateDate');
      // start section Address
      const Address = element.getElementsByTagName('cb:Address')[0].attributes?.Address?.value ?? ''
      const SubDistrict = element.getElementsByTagName('cb:Address')[0].attributes?.SubDistrict?.value ?? ''
      const District = element.getElementsByTagName('cb:Address')[0].attributes?.District?.value ?? ''
      const City = element.getElementsByTagName('cb:Address')[0].attributes?.City?.value ?? ''
      const PostalCode = element.getElementsByTagName('cb:Address')[0].attributes?.PostalCode?.value ?? ''
      const Country = element.getElementsByTagName('cb:Address')[0].attributes?.Country?.value ?? ''
      // end section address

      // start section address des
      const CityDesc = element.getElementsByTagName('cb:AddressDesc')[0]?.attributes?.CityDesc?.value ?? ''
      const CountryDesc = element.getElementsByTagName('cb:AddressDesc')[0]?.attributes?.CountryDesc?.value ?? ''
      // end section address des

      return { flagCurrent, lastUpdateDate, Address, SubDistrict, District, City, PostalCode, Country, CityDesc, CountryDesc }
    });
    // Attributes BusinessIdentificationCode
    const BusinessIdentityNumber = companyRoot?.getElementsByTagName('cb:BusinessIdentificationCode')[0]?.attributes?.BusinessIdentityNumber?.value ?? '';
    const LastUpdateDateID = companyRoot?.getElementsByTagName('cb:BusinessIdentificationCode')[0]?.attributes?.LastUpdateDate?.value ?? ''
    // Attributes ContactHistory
    const ContactHistory = Array.from(companyRoot.getElementsByTagName('cb:ContactHistory')).map(element => {
      const flagCurrent = element.getAttribute('FlagCurrent');
      const lastUpdateDate = element.getAttribute('LastUpdateDate');
      const PhoneNumber = element.getElementsByTagName('cb:Contacts')[0]?.attributes?.PhoneNumber?.value ?? ''
      const CellphoneNumber = element.getElementsByTagName('cb:Contacts')[0].attributes?.CellphoneNumber?.value ?? ''
      const EmailAddress = element.getElementsByTagName('cb:Contacts')[0]?.attributes?.EmailAddress?.value ?? ''

      return { flagCurrent, lastUpdateDate, PhoneNumber, CellphoneNumber, EmailAddress }
    })
    // Attributes Shareholders
    const ShareholdersRoot = companyRoot?.getElementsByTagName('cb:Shareholders')[0];
    const ShareholdersCounter = ShareholdersRoot?.getElementsByTagName('cb:ShareholdersSummary')[0]?.attributes?.ShareholdersCounter?.value ?? '';
    const ShareholdersData = Array.from(ShareholdersRoot?.getElementsByTagName('cb:ShareholdersData')).map(element => {
      // AttributeData
      const ProviderTypeCode = element?.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ProviderTypeCode?.value ?? '';
      const ProviderTypeCodeDesc = element?.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ProviderTypeCodeDesc?.value ?? '';
      const ProviderCode = element?.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ProviderCode?.value ?? '';
      const ProviderCodeDesc = element?.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ProviderCodeDesc?.value ?? '';
      const ReferenceDate = element?.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ReferenceDate?.value ?? '';
      // Shareholder
      const NameOfShareholder = element?.getElementsByTagName('cb:Shareholder')[0]?.attributes?.NameOfShareholder?.value ?? '';
      const Gender = element?.getElementsByTagName('cb:Shareholder')[0]?.attributes?.Gender?.value ?? '';
      const GenderDesc = element?.getElementsByTagName('cb:Shareholder')[0]?.attributes?.GenderDesc?.value ?? '';
      const NoOfShares = element?.getElementsByTagName('cb:Shareholder')[0]?.attributes?.NoOfShares?.value ?? '';
      const Position = element?.getElementsByTagName('cb:Shareholder')[0]?.attributes?.Position?.value ?? '';
      const PositionDesc = element?.getElementsByTagName('cb:Shareholder')[0]?.attributes?.PositionDesc?.value ?? '';
      const ManagerStatus = element?.getElementsByTagName('cb:Shareholder')[0]?.attributes?.ManagerStatus?.value ?? '';
      const ManagerStatusDesc = element?.getElementsByTagName('cb:Shareholder')[0]?.attributes?.ManagerStatusDesc?.value ?? '';
      // Address
      const Address = element?.getElementsByTagName('cb:Address')[0]?.firstElementChild?.attributes?.Address?.value ?? '';
      const SubDistrict = element?.getElementsByTagName('cb:Address')[0]?.firstElementChild?.attributes?.SubDistrict?.value ?? '';
      const District = element?.getElementsByTagName('cb:Address')[0]?.firstElementChild?.attributes?.District?.value ?? '';
      const City = element?.getElementsByTagName('cb:Address')[0]?.firstElementChild?.attributes?.City?.value ?? '';
      // AddressDesc
      const CityDesc = element?.getElementsByTagName('cb:AddressDesc')[0]?.attributes?.CityDesc?.value ?? '';
      // ShareholderIDNumber
      const IdentityType = element?.getElementsByTagName('cb:IdentificationCode')[0]?.attributes?.IdentityType?.value ?? '';
      const IdentityNumber = element?.getElementsByTagName('cb:IdentificationCode')[0]?.attributes?.IdentityNumber?.value ?? '';
      const IdentityTypeDesc = element?.getElementsByTagName('cb:IdentificationCodeDesc')[0]?.attributes?.IdentityTypeDesc?.value ?? '';

      return { ProviderTypeCode, ProviderTypeCodeDesc, ProviderCode, ProviderCodeDesc, ReferenceDate, NameOfShareholder, Gender, GenderDesc, NoOfShares, Position, PositionDesc, ManagerStatus, ManagerStatusDesc, Address, SubDistrict, District, City, CityDesc, IdentityType, IdentityNumber, IdentityTypeDesc }
    });

    const result = {
      ReferenceNo,
      CBSubjectCode,
      FlagMatched,
      CompanyCategory,
      LegalForm,
      LegalFormDesc,
      GoPublic,
      GoPublicDesc,
      Rating,
      RatingInstitution,
      RatingInstitutionDesc,
      RatingDate,
      EconomicSector,
      EconomicSectorDesc,
      LastUpdateDate,
      TradeName,
      PlaceOfEstablishment,
      DeedNumberOfEstablishment,
      DeedDateOfEstablishment,
      RecentlyeOfEstablishment,
      DateofFinalAmendmentDeedNumber,
      AddressHistory,
      BusinessIdentityNumber,
      LastUpdateDateID,
      ContactHistory,
      ShareholdersCounter,
      ShareholdersData,
    }

    return result;
  } else {
    const result = {
      FlagMatched,
      CBSubjectCode
    }
    return result;
  }

}

export default matchedSubjectB2b;